<!--单选 SCQ-->
<template>
  <div class="question-editor">
    <div class="question-pd">
      <div class="question-header">
        <div class="question-header-left">
          <div>
            <p class="question-number">
              {{
                `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、`
              }}
              <!-- <span v-if="isMust" class="asterisk">*</span> -->
            </p>
          </div>
          <div class="question-select">
            <p>投票</p>
          </div>
		  <div
		    class="add-batch"
		    style="margin-left: 10px"
		    @click="handleOptionSetting"
		  >
		    <div v-if="!isCountMust && !isCountSwitch">
		      <span style="font-size: 14px">当前设置:</span>
		      <span style="font-size: 14px">最多选{{ maxCount }}项</span>
		      <!-- <span style="font-size: 14px">最少选{{ minCount }}项</span> -->
		    </div>
		    <div v-if="isCountMust">
		      <span style="font-size: 14px">当前设置:</span>
		      <span style="font-size: 14px">必须选{{ maxCount }}项</span>
		    </div>
		    <div v-if="isCountSwitch">
		      <span style="font-size: 14px">当前设置:</span>
		      <span style="font-size: 14px">最多选{{ maxCount }}项</span>
		      <span style="font-size: 14px">最少选{{ minCount }}项</span>
		    </div>
		  </div>
        </div>
        <div class="question-header-right">
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596666801.png"
            lazy-load
            class="image-up"
            @click="handleOperateClick(2)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596715787.png"
            lazy-load
            class="image-down"
            @click="handleOperateClick(3)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596748508.png"
            lazy-load
            class="image-delete"
            @click="handleOperateClick(4)"
          />
        </div>
      </div>
      <div
        class="textarea-box"
        style="
          width: 100%;
          background: #ffffff;
          border: 1px solid #dcdde0;
          border-radius: 4px;
          padding: 12px;
          box-sizing: border-box;
          margin-top: 10px;
        "
      >
        <!-- <textarea
          placeholder-class="textarea-placeholder"
          v-model.lazy="this.caseProblem"
          placeholder="请选择一个选项"
          :cursor="5"
          maxlength="500"
          auto-height
          style="min-height: 120rpx; width: 100%"
          :disabled="this.dataObj.disabled"
          @focus="this.isFocusIndex = '-1'"
          @blur="this.isFocusIndex = ''"
        ></textarea> -->
        <textarea
          placeholder-class="textarea-placeholder"
          v-model="caseProblem"
          placeholder="请给以下项目进行投票"
          maxlength="500"
          auto-height
          @input="handleInput"
          @focus="isFocusIndex = '-1'"
          @blur="state.isFocusIndex = ''"
          rows="2"
          style="width: 100%; resize: none"
        ></textarea>
        <div
          class=""
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 8px;
          "
        >
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737857957020.png"
            mode=""
            style="width: 18px; height: 18px; cursor: pointer"
            @click="handleCaseProblemImg"
          />
          <div @click="clearQuestion" class="clear-btn">清空</div>
        </div>
      </div>
      <div class="question-images">
        <div
          v-for="(item, index) in images"
          :key="index"
          style="margin-top: 10px; position: relative"
        >
          <img :src="item" mode="widthFix" style="width: 100%" />
          <img
            src="@/assets/images/guanbi.png"
            mode="widthFix"
            class="guanbi"
            @click="handleDeleteQuestionImage(index)"
          />
        </div>
      </div>
      <div class="options">
        <div v-for="(option, index) in list" :key="index">
          <div class="option-item">
            <div class="option-item-top">
              <div class="option-item-top-left">
                <img
                  v-if="list.length > 2"
                  @click="delItem(index)"
                  class="del1"
                  src="https://ossfytp.mustke.com/image/newStyleImages/del-red.svg"
                />
                <img
                  v-else
                  class="del1"
                  src="https://ossfytp.mustke.com/image/newStyleImages/del-gray.svg"
                />
              </div>
              <div
                class="option-item-top-right"
                :style="{
                  border:
                    inputFocusIndex === `a${index}`
                      ? '1px solid rgba(58,96,255,0.5)'
                      : '1px solid #DCDDE0',
                }"
              >
                <div class="option-item-top-right-up">
                  <input
                    placeholder-class="input-placeholder"
                    type="text"
                    :placeholder="'选项' + (index + 1)"
                    v-model="option.text"
                    @input="handleInput"
                    @focus="inputFocusIndex = 'a' + index"
                    @blur="inputFocusIndex = ''"
                  />
                  <div class="option-item-top-right-right">
                    <img
                      src="https://ossfastmake.mustke.com/qrCode/tupian/1737857957020.png"
                      mode=""
                      style="
                        width: 18px;
                        height: 18px;
                        margin-right: 6px;
                        cursor: pointer;
                      "
                      @click="handleItemImage(index)"
                    />
                    <!-- <el-checkbox
                      label="填空"
                      v-model="option.is_fill"
                      :true-label="1"
                      :false-label="0"
                      @click.stop=""
                      class="my-checkbox"
                      style="transform: scale(1.0)"
                    ></el-checkbox> -->
                  </div>
                </div>

                <div class="question-images">
                  <div
                    class="question-images-box"
                    v-for="(imgItem, imgIndex) in option.img_path"
                    :key="index"
                    style="
                      margin-top: 10px;
                      position: relative;
                      margin-bottom: 5px;
                    "
                  >
                    <el-image
                      :src="imgItem"
                      :preview-src-list="[imgItem]"
                      class="thumbnail-image"
                    >
                    </el-image>
                    <div class="fangda-box">
                      查看图片
                      <!-- <img src="../../static/image/searchWhite.png" mode="" class="fangda"> -->
                    </div>
                    <img
                      src="@/assets/images/guanbi.png"
                      mode="widthFix"
                      class="guanbi"
                      @click="handleDeleteItemImage(index, imgIndex)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- <div v-if="option.is_fill" class="option-item-bottom">
              <div
                class="option-item-bottom-input"
                :style="{
                  border:
                    inputFocusIndex === `b${index}`
                      ? '1px solid rgba(58,96,255,0.5)'
                      : '1px solid #DCDDE0',
                }"
              >
                <input
                  placeholder-class="input-placeholder"
                  type="text"
                  placeholder="编辑提示词"
                  v-model="option.fill_prompt"
                  @input="handlePromptInput"
                  @focus="inputFocusIndex = `b${index}`"
                  @blur="inputFocusIndex = ''"
                />
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="add-view">
        <div class="add-batch" style="color: #ffffff">
          <el-checkbox
            label="必选题"
            v-model="isMust"
            :true-label="1"
            :false-label="0"
            class="custom-checkbox"
            @change="handleCheckboxChange"
          ></el-checkbox>
        </div>
        <div @click="addOption" class="add-btn">
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737858857723.png"
            mode=""
            style="width: 13px; height: 13px"
          />
          <p>添加选项 {{ list.length + "/50" }}</p>
        </div>
        <div @click="batchAddOptions" class="add-batch">批量添加</div>
      </div>
    </div>
    <div v-if="type === 1" class="option-settings">
      <p></p>
      <el-checkbox
        label="展示投票结果"
        v-model="ifShowResult"
        style="transform: scale(1)"
      ></el-checkbox>
    </div>
    <div v-if="type === 1" class="question-footer">
      <!-- <div class="cancel-btn" @click="cancelClick">取消</div> -->
      <div class="save-btn" @click="saveClick">保存</div>
    </div>
    <PopupInput
      :showDialog="showpopup"
      @close="showpopup = false"
      @confirm="bitchConfirm"
      :type="1"
    ></PopupInput>
	<div class="coverShow" v-show="dialogVisible">
	  <div class="container-gj">
	    <div class="container-gd">
	      <div class="header-div">
	        <div
	          style="
	            font-size: 18px;
	            font-weight: 600;
	            color: #2b2f36;
	            line-height: 24px;
	            position: absolute;
	            top: 50%;
	            left: 50%;
	            transform: translate(-50%, -50%);
	          "
	        >
	          选择设置
	        </div>
	        <img
	          src="https://ossfastmake.mustke.com/qrCode/tupian/1736759941513.png"
	          mode=""
	          @click="dialogVisible = false"
	          style="width: 13px; height: 13px; position: absolute; right: 20px"
	        />
	      </div>
	      <div
	        v-if="!isCountMust && !isCountSwitch"
	        style="
	          display: flex;
	          justify-content: flex-start;
	          padding: 0 15px;
	          box-sizing: border-box;
	          height: 40px;
	          line-height: 40px;
	          border-bottom: 1px solid #e5e5e5;
	        "
	      >
	        <span style="font-size: 14px; color: #a7adc6">当前设置:</span>
	        <span style="font-size: 14px; color: #a7adc6"
	          >最多选{{ maxCount }}项</span
	        >
	      </div>
	      <div
	        v-if="isCountMust"
	        style="
	          display: flex;
	          justify-content: flex-start;
	          padding: 0 15px;
	          box-sizing: border-box;
	          height: 40px;
	          line-height: 40px;
	          border-bottom: 1px solid #e5e5e5;
	        "
	      >
	        <span style="font-size: 14px; color: #a7adc6">当前设置:</span>
	        <span style="font-size: 14px; color: #a7adc6"
	          >必须选{{ maxCount }}项</span
	        >
	      </div>
	      <div
	        v-if="isCountSwitch"
	        style="
	          display: flex;
	          justify-content: flex-start;
	          padding: 0 15px;
	          box-sizing: border-box;
	          height: 40px;
	          line-height: 40px;
	          border-bottom: 1px solid #e5e5e5;
	        "
	      >
	        <!-- <span style="font-size: 14px; color: #a7adc6">当前设置:</span>
	        <span style="font-size: 14px; color: #a7adc6"
	          >最少选{{ minCount }}项</span
	        > -->
	        <span style="font-size: 14px; color: #a7adc6">当前设置:</span>
	        <span style="font-size: 14px; color: #a7adc6"
	          >最多选{{ maxCount }}项，</span
	        >
	        <span style="font-size: 14px; color: #a7adc6"
	          >最少选{{ minCount }}项</span
	        >
	      </div>
	      <div class="count-item">
	        <div style="display: flex; align-items: center">
	          <div style="font-size: 14px">最多选</div>
	          <el-input-number
	            v-model="maxCount"
	            :min="1"
	            :max="list.length"
	            style="margin-left: 10px"
	            @blur="handleMaxCountBlur"
	          ></el-input-number>
	          <div style="margin-left: 10px; font-size: 14px">项</div>
	        </div>
	        <el-checkbox
	          label="必选题"
	          v-model="isCountMust"
	          :true-label="1"
	          :false-label="0"
	          class="custom-checkbox"
	          @change="handleCountMustChange"
	        ></el-checkbox>
	      </div>
	      <div class="count-item">
	        <div style="display: flex; align-items: center">
	          <div style="font-size: 14px">最少选</div>
	          <el-input-number
	            v-model="minCount"
	            :min="1"
	            :max="maxCount"
	            style="margin-left: 10px"
	            @blur="handleMinCountBlur"
	          ></el-input-number>
	          <div style="margin-left: 10px; font-size: 14px">项</div>
	        </div>
	        <el-switch
	          v-model="isCountSwitch"
	          active-color="#13ce66"
	          inactive-color="#EDEDED"
	          :active-value="1"
	          :inactive-value="0"
	          @change="handleCountSwitchChange"
	        >
	        </el-switch>
	      </div>
	      <div style="width: 100%; display: flex; justify-content: center">
	        <el-button
	          type="primary"
	          @click="handleCountConfirm"
	          style="width: 120px; margin: 20px auto"
	          >确定</el-button
	        >
	      </div>
	    </div>
	  </div>
	</div>
    <input
      type="file"
      ref="fileInput"
      accept="image/*"
      style="display: none"
      @change="handleFileChange"
    />
  </div>
</template>

<script>
import PopupInput from "@/components/PopupInput/PopupInput.vue";
import axios from "axios";
import baseURL from "../../utils/bsaeUrl";

export default {
  components: {
    PopupInput,
  },
  props: {
    params: {
      type: Object,
      default: {},
    },
    index: {
      type: Number,
      default: 0,
    },
    uuid: {
      type: String,
      default: "",
    },
    type: {
      type: Number,
      default: 1, // 1 添加问卷 2 添加题库
    },
    updateType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      list: [],
      dataObj: {},
      ifRandomize: false,
      isMust: false,
      showpopup: false,
      showUpload: false,
      uploadIndex: 0,
      images: [],
      caseProblem: "",
      isFocusIndex: "",
      inputFocusIndex: "",
      ifShowResult: false,
	  dialogVisible: false,
	  maxCount: 1,
	  minCount: 1,
	  isCountMust: 0,
	  isCountSwitch: 0,
    };
  },
  methods: {
    handleFileChange(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("file", file); // "file" 对应后端接收的字段名
      formData.append("uuid", this.uuid);
      this.$refs.fileInput.value = "";
      axios
        .post(baseURL + "/PCwj/file/uploads", formData, {
          headers: {
            "Content-Type": "multipart/form-data", // 必须设置
            token: localStorage.getItem("token"),
          },
        })
        .then((response) => {
          this.$message.success("上传成功！");
          if (this.uploadIndex === -1) {
            this.images = [response.data.urls];
          } else {
            this.list[this.uploadIndex].img_path = [response.data.urls];
          }
          this.handleUpdateQuestion();
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            console.log("上传已取消:", error.message);
          } else {
            this.$message.error("上传失败！");
          }
        });
    },

    handleOperateClick(type) {
      this.$emit(
        "operate",
        JSON.stringify({
          type: type,
          index: this.index,
        }),
      );
    },
	handleCountSwitchChange() {
	  if (this.isCountSwitch) {
	    this.isCountMust = 0;
	  }
	  this.handleUpdateQuestion();
	  console.log(
	    "888888888888888888888",
	    this.isCountMust,
	    this.isCountSwitch,
	  );
	},
	handleCountMustChange() {
	  if (this.isCountMust) {
	    this.isCountSwitch = 0;
	  }
	  this.handleUpdateQuestion();
	  console.log(
	    "999999999999999999999",
	    this.isCountMust,
	    this.isCountSwitch,
	  );
	},
    handleInput() {
      this.handleUpdateQuestion();
    },
    handlePromptInput() {
      this.handleUpdateQuestion();
    },
    clearQuestion() {
      this.caseProblem = "";
      this.handleUpdateQuestion();
    },
    addOption() {
      if (this.list.length < 50) {
        this.list.push({
          id: "", //后台处理逻辑 创建时不传 唯一标识用
          text: "",
          isChoose: false,
          img_path: [],
          is_fill: 0, //是否填空 0否 1是
          fill_prompt: "",
          newDate: true,
        });
        this.handleUpdateQuestion();
      } else {
        this.$message.error("最多只能添加50个选项");
      }
    },

    batchAddOptions() {
      // 批量添加选项的逻辑
      this.showpopup = true;
    },
    bitchConfirm(e) {
      // 批量添加选项的逻辑
      this.showpopup = false;
      const count = e.split("\n").filter((item) => item.trim() !== "").length;
      if (count > 50 - this.list.length) {
        this.$message.error("最多只能添加50个选项");
        return;
      }
      const list = e
        .split("\n")
        .filter((item) => item.trim() !== "")
        .map((item) => {
          return {
            id: "", //后台处理逻辑 创建时不传 唯一标识用
            text: item,
            isChoose: false,
            img_path: [],
            is_fill: 0, //是否填空 0否 1是
            fill_prompt: "",
            newDate: true,
          };
        });
      this.list = this.list.concat(list);
      this.handleUpdateQuestion();
    },
    delItem(index) {
      if (this.updateType === 1) {
        if (this.list[index].newDate) {
          this.list.splice(index, 1);
        } else {
          this.$message.error("限制性修改状态下，不能删除之前的数据!");
        }
      } else {
        this.list.splice(index, 1);
      }
      this.handleUpdateQuestion();
    },
    handleCaseProblemImg() {
      this.uploadIndex = -1;
      this.$refs.fileInput.click();
    },
    handleItemImage(index) {
      this.uploadIndex = index;
      this.$refs.fileInput.click();
    },

    handleDeleteQuestionImage(index) {
      this.images.splice(index, 1);
      this.handleUpdateQuestion();
    },
    handleDeleteItemImage(index, imgIndex) {
      this.list[index].img_path.splice(imgIndex, 1);
      this.handleUpdateQuestion();
    },
	handleOptionSetting() {
	  this.dialogVisible = true;
	},
	handleCountConfirm() {
	  this.dialogVisible = false;
	  this.handleUpdateQuestion();
	},
    handleCheckboxChange() {
      this.isMust = !this.isMust;
      this.handleUpdateQuestion();
    },
    handleUpdateQuestion() {
	  console.log("this.minCount-更新", this.minCount);
	  console.log("this.maxCount-更新", this.maxCount);
		
      this.dataObj.isMust = this.isMust ? 1 : 0;
      this.dataObj.caseProblemImg = JSON.stringify(this.images);
      this.dataObj.caseProblem = this.caseProblem;
      this.dataObj.chooseList = JSON.stringify({
        list: this.list.map((item, index) => {
          item.is_fill = item.is_fill ? 1 : 0;
          return item;
        }),
		minCount: this.minCount,
		maxCount: this.maxCount,
		isCountMust: this.isCountMust,
		isCountSwitch: this.isCountSwitch,
      });
      this.dataObj.ifShowResult = this.ifShowResult ? 1 : 0;
      this.$emit(
        "update",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    cancelClick() {
      this.$emit(
        "cancel",
        JSON.stringify({
          index: props.index,
          data: this.dataObj,
        }),
      );
    },
    saveClick() {
      if (this.caseProblem.includes(" ") && this.caseProblem.trim() === "") {
        this.$message.error("请输入题目");
      }

      this.dataObj.isMust = this.isMust ? 1 : 0;
      this.dataObj.caseProblemImg = JSON.stringify(this.images);
      this.dataObj.caseProblem =
        this.caseProblem === "" ? "请给以下项目进行投票" : this.caseProblem;
      this.dataObj.chooseList = JSON.stringify({
        list: this.list.map((item, index) => {
          item.is_fill = item.is_fill ? 1 : 0;
          item.text = item.text === "" ? `选项${index + 1}` : item.text;
          return item;
        }),
		minCount: this.minCount,
		maxCount: this.maxCount,
		isCountMust: this.isCountMust,
		isCountSwitch: this.isCountSwitch,
      });
      this.dataObj.ifShowResult = this.ifShowResult ? 1 : 0;
      this.$emit(
        "save",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    handleClick() {},
	handleMinCountBlur(e) {
	  if (this.minCount === undefined || this.minCount === null) {
	    this.minCount = 1;
	  }
	},
	handleMaxCountBlur(e) {
	  if (this.maxCount === undefined || this.maxCount === null) {
	    this.maxCount = this.minCount;
	  }
	},
  },
  watch: {
    params: {
      handler(newVal, oldVal) {
        console.log("dataObj 变化了", newVal, oldVal);
        this.dataObj = newVal;
        this.caseProblem = newVal.caseProblem;
        this.list = JSON.parse(newVal.chooseList).list.map((item) => {
          item.is_fill = item.is_fill === 1;
          return item;
        });
		this.minCount = JSON.parse(newVal.chooseList).minCount;
		this.maxCount = JSON.parse(newVal.chooseList).maxCount;
		this.minCount;
        this.isMust = newVal.isMust === 1;
        this.images = JSON.parse(newVal.caseProblemImg);
        this.ifShowResult = newVal.ifShowResult === 1;
		this.isCountMust = JSON.parse(newVal.chooseList).isCountMust;
		this.isCountSwitch = JSON.parse(newVal.chooseList).isCountSwitch;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
button {
  margin-left: 10px;
}

.add-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.add-batch {
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #509dee;
  line-height: 20px;
  cursor: pointer;
}

.minus {
  width: 19px;
  height: 19px;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.input {
  padding: 0 10px;
  background: #ffffff;
}

.plus {
  width: 19px;
  height: 19px;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.question-header-left {
  display: flex;
  align-items: center;
}

.question-header-right {
  display: flex;
  align-items: center;
}

.option-item-top-right input {
  color: #4c4a56;
}
.textarea-box textarea {
  color: #4c4a56;
}

::v-deep(.u-checkbox__label-wrap) {
  white-space: nowrap;
  writing-mode: horizontal-tb;
}

.edit_add_number {
  margin: 10px;

  .item {
    display: flex;
    align-items: center;
    margin-left: 30px;
    font-size: 14px;
    color: #606266;
    width: 200px;

    .titles {
      font-size: 14px;
      color: #606266;
      word-break: keep-all;
    }
  }
}

.count-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  padding: 0 15px;
  box-sizing: border-box;
}

.coverShow {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.container-gj {
  padding: 15px;
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  border-radius: 8px;
  z-index: 10000000;
  transform: translate(-50%, -50%);
  padding: 20px;
}

.container-gd {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 400px;
  /* height: 80vh; */
  background: #ffffff;
  border-radius: 8px;
  z-index: 10000000;
  transform: translate(-50%, -50%);
  overflow: hidden;
  overflow-y: auto;
}

.header-div {
  width: 100%;
  height: 59px;
  background-color: #ffffff;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  padding: 0 14px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e7e7e7;
  position: relative;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionEdit/QuestionEditVote.vue